import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { RegionContext } from "../../../context/RegionContext";
import { getFeaturedCasinosByRegion } from "../../../controllers/homeController";
import CasinoCard from "../global/CasinoCard";

const FeaturedCasinos = () => {
  const { selectedRegionId } = useContext(RegionContext);
  const navigate = useNavigate();

  const [openIndex, setOpenIndex] = useState(null);
  const [casinos, setCasinos] = useState([]);
  const [loading, setLoading] = useState(true);

  const toggleDetails = (index) =>
    setOpenIndex((prev) => (prev === index ? null : index));

  const fetchFeaturedCasinos = async () => {
    try {
      const storedRegionId =
        selectedRegionId || localStorage.getItem("selectedRegionId");
      if (!storedRegionId) {
        setCasinos([]);
        setLoading(false);
        return;
      }
      const featuredList = await getFeaturedCasinosByRegion(storedRegionId);
      const formatted = (featuredList || []).map((f) => ({
        id: f.id,
        Name: f.name,
        ImageUrl: f.imageUrl,
        Rating: f.rating,
        BestFor: f.bestFor,
        PayoutSpeed: f.payoutSpeed,
        Rtp: f.rtp,
        WelcomeOffer: f.welcomeOffer,
        MinDeposit: f.minDeposit,
        CasinoUrl: f.casinoUrl,
        PaymentMethods: f.paymentMethods || [],
        promoCode: f.promoCode || "",
      }));
      setCasinos(formatted);
      setLoading(false);
      if (formatted.length > 0) setOpenIndex(0);
    } catch (err) {
      console.error("Error fetching featured casinos:", err);
      setCasinos([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFeaturedCasinos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRegionId]);

  const handleDetailsClick = (casino) =>
    navigate("/casino-details", { state: { casino } });

  return (
    <section className="bg-bggray !py-6  dark:bg-gray-800 text-textLight dark:text-textDark pt-0 pb-10 transition-colors duration-300">
      <div className="w-full mx-auto max-w-[1400px] 2xl:max-w-[1600px] px-6 xl:px-20">
        <h2 className="text-left text-2xl sm:text-3xl font-extrabold tracking-tight mb-4 dark:text-textDark">
          The best online casinos
        </h2>

        {loading ? (
          <div className="space-y-4">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className="h-32 rounded-xl border border-border dark:border-borderDark bg-cardLight dark:bg-cardDark animate-pulse"
              />
            ))}
          </div>
        ) : !casinos.length ? (
          <p className="text-textLight/70 dark:text-textDark/70 mt-4 text-center">
            No featured casinos available for your region.
          </p>
        ) : (
          <div className="space-y-6">
            {casinos.map((casino, index) => (
              <CasinoCard
                key={casino.id || index}
                casino={casino}
                index={index}
                isOpen={openIndex === index}
                onToggle={toggleDetails}
                onDetailsClick={handleDetailsClick}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default FeaturedCasinos;
